import { App as P_AirHandlingUnit } from './AirHandlingUnits/P_AirHandlingUnit/appDeclaration';
import { App as P_HeatingGenerator } from './Heatings/P_HeatingGenerator/appDeclaration';
import { App as P_HeatingOutlet } from './Heatings/P_HeatingOutlet/appDeclaration';
import { App as P_HeatingCoolingOutlet } from './HeatingCoolings/P_HeatingCoolingOutlet/appDeclaration';
import { App as P_HeatingPuffer } from './Heatings/P_HeatingPuffer/appDeclaration';
import { App as P_CoolingGenerator } from './Coolings/P_CoolingGenerator/appDeclaration';
import { App as P_CoolingOutlet } from './Coolings/P_CoolingOutlet/appDeclaration';
import { App as P_Common } from './Commons/P_Common/appDeclaration';
import { App as P_BuildingApp } from './Buildings/P_Building/appDeclaration';
import { App as P_RoomAutomation } from './Buildings/P_RoomAutomation/appDeclaration';
import { App as P_Floor } from './Buildings/P_Floor/appDeclaration';
import { App as AHU_Optimizer } from './Optimizations/AHU_Optimizer/appDeclaration';
import { App as IHeatingOutlet_Optimizer } from './Optimizations/HeatingOutlet_Optimizer/appDeclaration';

export const Apps = {
    [P_AirHandlingUnit.schema]: P_AirHandlingUnit,
    [P_HeatingGenerator.schema]: P_HeatingGenerator,
    [P_HeatingOutlet.schema]: P_HeatingOutlet,
    [P_HeatingCoolingOutlet.schema]: P_HeatingCoolingOutlet,
    
    [P_HeatingPuffer.schema]: P_HeatingPuffer,
    [P_CoolingGenerator.schema]: P_CoolingGenerator,
    [P_CoolingOutlet.schema]: P_CoolingOutlet,
    [P_Common.schema]: P_Common,
    [P_BuildingApp.schema]: P_BuildingApp,
    [P_RoomAutomation.schema]: P_RoomAutomation,
    [P_Floor.schema]: P_Floor,
    [AHU_Optimizer.schema]: AHU_Optimizer,
    [IHeatingOutlet_Optimizer.schema]: IHeatingOutlet_Optimizer,
}